module.exports = __webpack_public_path__ + "img/loghi.0509140c.svg";